import * as constants from '../constants/aoi';

/**
 * Sets the AOI list
 *
 * @export
 * @param {Array<object>} aois
 * @returns {object}
 */
export function setAois (aois) {
    return {
        type: constants.SET_AOIS,
        aois
    }
}



// WEBPACK FOOTER //
// ./src/actions/aoi.js